const CLOUD_NAME = "dqecqdmoy"; // your real one
const UPLOAD_PRESET = "solar_products_upload";

export const uploadImage = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", UPLOAD_PRESET);

  const res = await fetch(
    `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
    {
      method: "POST",
      body: formData,
    },
  );

  const data = await res.json();

  console.log("Cloudinary response:", data); // 👈 IMPORTANT DEBUG

  if (!data.secure_url) {
    throw new Error(data.error?.message || "Image upload failed");
  }

  return data.secure_url;
};
